import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const deleteAct = (act, user) => {
  return requestWithPromise('/api/Act/' + getIdOrNull(act), HttpMethods.DELETE, null, user)
}
